import { conversionMap } from "../../constants/legacy-to-focus-dimension-map";
import { ScopedViewFilter } from "../../core/types";
import { billingFocusSchema } from "../schemas/billingFOCUS";

function translateBillingVendorToFocusProvider(billingVendor: string): string {
  switch (billingVendor) {
    case "Amazon":
      return "AWS";
    case "Google":
      return "Google Cloud";
    default:
      return billingVendor;
  }
}

// NOTE: Temporary shim to make CUC Billing Scoped Views work with FOCUS Billing.
// Attempts to convert a legacy dimension to a focus dimension.
// If it can't be converted, it returns the original filter.
export function convertLegacyFilterToFocusFilter(
  filter: ScopedViewFilter
): ScopedViewFilter {
  let name = conversionMap[filter.name];

  if (!name) {
    name = `TERNARY_CUSTOM_LABEL/${encodeURIComponent(filter.name)}`;
  }

  let values = filter.values;

  if (
    values &&
    name === billingFocusSchema.dimensions.providerType.schemaName
  ) {
    values = values.map(translateBillingVendorToFocusProvider);
  }

  return {
    ...filter,
    name,
    values,
  };
}
